import React from 'react';
import { Table, Input, Dropdown, Button, Checkbox } from 'semantic-ui-react';
import { connect } from 'react-redux';
import {
  H1,
  H2,
  StyledLink,
  LinkBlock,
  TableBlock,
  ButtonBlock,
  FooterBlock,
  Warning,
} from './CreateProductStyles';
import {
  defaultMeasureOfWeightlist,
  product_tags_id,
  taste,
  teaSpoon,
  tableSpoon,
} from '../youslim2.0_Constants';
import { toastError } from '../../../utils/toastMessage';
import * as action from '../../../actions/newYouslim';
import ProductsTagsBlock from '../TagsBlock/ProductsTagsBlock';
import UpdateProductModal from '../ProductUpdateModal';
import Navbar from '../Navigation/Navbar';

const CreateProductPage = React.memo(
  ({
    match,
    getProductTags,
    createProduct,
    allTags,
    currentProduct,
    updateProduct,
    getProductById,
    setCurrentProduct,
    isProductLoading,
  }) => {
    const [productName, setProductName] = React.useState(currentProduct ? currentProduct.name : '');
    const [numberOfCalories, setNumberOfCalories] = React.useState(
      currentProduct ? +currentProduct.calories : 0,
    );
    const [numberOfAnimalProtein, setNumberOfAnimalProtein] = React.useState(
      currentProduct ? +currentProduct.animal_protein : 0,
    );
    const [numberOfPlantProtein, setNumberOfPlantProtein] = React.useState(
      currentProduct ? +currentProduct.vegetable_protein : 0,
    );
    const [numberOfSaturatedFat, setNumberOfSaturatedFat] = React.useState(
      currentProduct ? +currentProduct.saturated_fat : 0,
    );
    const [numberOfUnsaturatedFats, setNumberOfUnsaturatedFats] = React.useState(
      currentProduct ? +currentProduct.unsaturated_fats : 0,
    );

    const [numberOfSimpleCarbohydrates, setNumberOfSimpleCarbohydrates] = React.useState(
      currentProduct ? +currentProduct.simple_carbohydrates : 0,
    );
    const [numberOfComplexCarbohydrates, setNumberOfComplexCarbohydrates] = React.useState(
      currentProduct ? +currentProduct.complex_carbohydrates : 0,
    );
    const [numberOfCellulose, setNumberOfCellulose] = React.useState(
      currentProduct ? +currentProduct.cellulose : 0,
    );
    const [measureOfWeight, setMeasureOfWeight] = React.useState(
      currentProduct
        ? `${
            1 +
            defaultMeasureOfWeightlist.findIndex(
              (measure) => measure.text === currentProduct.measure,
            )
          }`
        : '',
    );
    const [isInvalidName, setIsInvalidName] = React.useState(false);
    const [choosedTags, setChoosedTags] = React.useState(
      currentProduct && currentProduct.tags ? currentProduct.tags.map((tag) => tag.id) : [],
    );
    const [isShowUpdatePopup, setIsShowUpdatePopup] = React.useState(false);
    const [requestDataForUpdate, setRequestDataForUpdate] = React.useState(false);

    const [showQuantity, setShowQuantity] = React.useState(
      currentProduct ? currentProduct.show_quantity : true,
    );
    React.useEffect(() => {
      if (currentProduct) {
        setProductName(currentProduct.name);
        setNumberOfCalories(+currentProduct.calories);
        setNumberOfAnimalProtein(+currentProduct.animal_protein);
        setNumberOfPlantProtein(+currentProduct.vegetable_protein);
        setNumberOfSaturatedFat(+currentProduct.saturated_fat);
        setNumberOfUnsaturatedFats(+currentProduct.unsaturated_fats);

        setNumberOfSimpleCarbohydrates(+currentProduct.simple_carbohydrates);
        setNumberOfComplexCarbohydrates(+currentProduct.complex_carbohydrates);
        setNumberOfCellulose(+currentProduct.cellulose);
        setMeasureOfWeight(
          `${
            1 +
            defaultMeasureOfWeightlist.findIndex(
              (measure) => measure.text === currentProduct.measure,
            )
          }`,
        );
        setChoosedTags(currentProduct.tags ? currentProduct.tags.map((tag) => tag.id) : []);
        setShowQuantity(currentProduct.show_quantity);
      }
    }, [currentProduct]);

    const onHandleСlear = React.useCallback(() => {
      setProductName('');
      setNumberOfCalories('');
      setNumberOfAnimalProtein('');
      setNumberOfPlantProtein('');
      setNumberOfSaturatedFat('');
      setNumberOfUnsaturatedFats('');
      setNumberOfSimpleCarbohydrates('');
      setNumberOfComplexCarbohydrates('');
      setNumberOfCellulose('');
      setMeasureOfWeight('');
      setChoosedTags([]);
      setCurrentProduct({});
      setShowQuantity(true);
    }, [
      setProductName,
      setNumberOfCalories,
      setNumberOfAnimalProtein,
      setNumberOfPlantProtein,
      setNumberOfSaturatedFat,
      setNumberOfUnsaturatedFats,
      setNumberOfSimpleCarbohydrates,
      setNumberOfComplexCarbohydrates,
      setNumberOfCellulose,
      setMeasureOfWeight,
      setChoosedTags,
      setShowQuantity,
    ]);

    React.useEffect(() => {
      const productId = match && match.params && match.params.id;
      if (productId) getProductById(productId);
      getProductTags(product_tags_id);
      return () => {
        setCurrentProduct({});
        onHandleСlear();
      };
    }, []);

    const onHandleSave = React.useCallback(() => {
      let isNutrientsFilled = false;
      let isName = false;
      let isMeasureOfWeight = false;
      let isTagsNotEmpty = false;
      let isCheckMustBeFalse = true;
      if (productName) {
        isName = true;
        setIsInvalidName(false);
      } else {
        isName = false;
        toastError('Введите название продукта');
        setIsInvalidName(true);
      }

      if (numberOfCalories > 0 || measureOfWeight === taste) {
        isNutrientsFilled = true;
      } else {
        toastError('Количество калории должно быть больше 0');
        isNutrientsFilled = false;
      }
      if (measureOfWeight) {
        isMeasureOfWeight = true;
      } else {
        isMeasureOfWeight = false;
      }
      if (choosedTags.length || measureOfWeight === taste) {
        isTagsNotEmpty = true;
      } else {
        isTagsNotEmpty = false;
        toastError('Выберите хотя бы один тег');
      }
      if (isNutrientsFilled && isName && isMeasureOfWeight && isTagsNotEmpty) {
        let requestData = {};
        if (measureOfWeight === taste) {
          requestData = {
            name: productName,
            calories: 0,
            animal_proteins: 0,
            plant_proteins: 0,
            saturated_fats: 0,
            unsaturated_fats: 0,
            simple_carbohydrates: 0,
            complex_carbohydrates: 0,
            cellulose: 0,
            measure_id: +measureOfWeight,
            show_quantity: false,
          };
          if (choosedTags.length) requestData.tags = choosedTags;
        } else {
          requestData = {
            name: productName,
            calories: Math.ceil(+numberOfCalories),
            animal_proteins: Math.round(+numberOfAnimalProtein * 100) / 100,
            plant_proteins: Math.round(+numberOfPlantProtein * 100) / 100,
            saturated_fats: Math.round(+numberOfSaturatedFat * 100) / 100,
            unsaturated_fats: Math.round(+numberOfUnsaturatedFats * 100) / 100,
            simple_carbohydrates: Math.round(+numberOfSimpleCarbohydrates * 100) / 100,
            complex_carbohydrates: Math.round(+numberOfComplexCarbohydrates * 100) / 100,
            cellulose: Math.round(+numberOfCellulose * 100) / 100,
            measure_id: Math.round(+measureOfWeight * 100) / 100,
            tags: choosedTags,
            show_quantity:
              measureOfWeight === teaSpoon || measureOfWeight === tableSpoon ? false : showQuantity,
          };
        }

        if (currentProduct.name) {
          setRequestDataForUpdate(requestData);
          setIsShowUpdatePopup(true);
        } else {
          createProduct(requestData, onHandleСlear);
        }
      }
    }, [
      productName,
      numberOfCalories,
      numberOfAnimalProtein,
      numberOfPlantProtein,
      numberOfSaturatedFat,
      numberOfUnsaturatedFats,
      numberOfSimpleCarbohydrates,
      numberOfComplexCarbohydrates,
      numberOfCellulose,
      measureOfWeight,
      choosedTags,
      showQuantity,
      onHandleСlear,
      currentProduct,
    ]);

    const onChangeNutrient = React.useCallback((value, onChange) => {
      if (value !== '' && value <= 0) {
        onChange(0);
      } else onChange(value);
    }, []);

    const onHandleUpdate = React.useCallback(() => {
      updateProduct(requestDataForUpdate, currentProduct.id);
      setIsShowUpdatePopup(false);
    }, [requestDataForUpdate, currentProduct, updateProduct]);

    const onHandleCreate = React.useCallback(() => {
      createProduct(requestDataForUpdate, onHandleСlear);
      setIsShowUpdatePopup(false);
    }, [requestDataForUpdate, currentProduct, onHandleСlear, createProduct]);

    return (
      <React.Fragment>
        <Navbar />
        <H1>{currentProduct.id ? 'Редактирование продукта' : 'Создание продуктов'}</H1>
        <H2>Содержание нутриентов указывать на выбраную меру веса продукта!</H2>
        <Warning>
          {currentProduct.id &&
            'Внимание! Изменённый продукт обновится во всех блюдах и у всех клиентов!'}
        </Warning>
        <TableBlock>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Название Продукта</Table.HeaderCell>
                <Table.HeaderCell collapsing>Калорийность</Table.HeaderCell>
                <Table.HeaderCell collapsing>
                  Животный <br /> белок
                </Table.HeaderCell>
                <Table.HeaderCell collapsing>
                  Pастительный <br /> белок
                </Table.HeaderCell>
                <Table.HeaderCell collapsing>
                  Насыщенные
                  <br /> жиры
                </Table.HeaderCell>
                <Table.HeaderCell collapsing>
                  Ненасыщенные
                  <br /> жиры
                </Table.HeaderCell>
                <Table.HeaderCell collapsing>
                  Простые <br /> углеводы
                </Table.HeaderCell>
                <Table.HeaderCell collapsing>
                  Сложные
                  <br /> углеводы
                </Table.HeaderCell>
                <Table.HeaderCell collapsing> Клетчатка</Table.HeaderCell>
                <Table.HeaderCell collapsing>Мера веса</Table.HeaderCell>
                <Table.HeaderCell collapsing>Корзина?</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell>
                  <Input
                    className="product-name-input"
                    placeholder="Введите название продукта"
                    value={productName}
                    error={isInvalidName}
                    onChange={(e) => setProductName(e.target.value)}
                  />
                </Table.Cell>
                <Table.Cell>
                  <Input
                    className="table-cell-width"
                    placeholder="Введите калорийность"
                    type="number"
                    disabled={measureOfWeight === taste}
                    value={numberOfCalories}
                    onChange={(e) => onChangeNutrient(e.target.value, setNumberOfCalories)}
                  />
                </Table.Cell>
                <Table.Cell>
                  <Input
                    className="table-cell-width"
                    placeholder="Введите количество животных белков"
                    type="number"
                    disabled={measureOfWeight === taste}
                    value={numberOfAnimalProtein}
                    onChange={(e) => onChangeNutrient(e.target.value, setNumberOfAnimalProtein)}
                  />
                </Table.Cell>
                <Table.Cell>
                  <Input
                    className="table-cell-width"
                    placeholder="Введите количество растительных белков"
                    type="number"
                    disabled={measureOfWeight === taste}
                    value={numberOfPlantProtein}
                    onChange={(e) => onChangeNutrient(e.target.value, setNumberOfPlantProtein)}
                  />
                </Table.Cell>
                <Table.Cell>
                  <Input
                    className="table-cell-width"
                    placeholder="Введите количество насыщенных жиров"
                    type="number"
                    disabled={measureOfWeight === taste}
                    value={numberOfSaturatedFat}
                    onChange={(e) => onChangeNutrient(e.target.value, setNumberOfSaturatedFat)}
                  />
                </Table.Cell>
                <Table.Cell>
                  <Input
                    className="table-cell-width"
                    placeholder="Введите количество ненасыщенных жиров"
                    type="number"
                    disabled={measureOfWeight === taste}
                    value={numberOfUnsaturatedFats}
                    onChange={(e) => onChangeNutrient(e.target.value, setNumberOfUnsaturatedFats)}
                  />
                </Table.Cell>
                <Table.Cell>
                  <Input
                    className="table-cell-width"
                    placeholder="Введите количество простых углеводов"
                    type="number"
                    disabled={measureOfWeight === taste}
                    value={numberOfSimpleCarbohydrates}
                    onChange={(e) =>
                      onChangeNutrient(e.target.value, setNumberOfSimpleCarbohydrates)
                    }
                  />
                </Table.Cell>
                <Table.Cell>
                  <Input
                    className="table-cell-width"
                    placeholder="Введите количество сложных углеводов"
                    type="number"
                    disabled={measureOfWeight === taste}
                    value={numberOfComplexCarbohydrates}
                    onChange={(e) =>
                      onChangeNutrient(e.target.value, setNumberOfComplexCarbohydrates)
                    }
                  />
                </Table.Cell>
                <Table.Cell>
                  <Input
                    className="table-cell-width"
                    placeholder="Введите количество клетчатки"
                    type="number"
                    disabled={measureOfWeight === taste}
                    value={numberOfCellulose}
                    onChange={(e) => onChangeNutrient(e.target.value, setNumberOfCellulose)}
                  />
                </Table.Cell>
                <Table.Cell>
                  <Dropdown
                    className="table-cell-width"
                    style={{
                      textAlign: 'center',
                    }}
                    value={measureOfWeight}
                    onChange={(e, data) => setMeasureOfWeight(data.value)}
                    placeholder="Меру веса"
                    options={defaultMeasureOfWeightlist}
                  />
                </Table.Cell>
                <Table.Cell>
                  <Checkbox
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      backgroundColor: 'white',
                      width: '45px',
                    }}
                    className="product_tags"
                    data-title={'Выводить количество продукта в Корзине?'}
                    disabled={
                      measureOfWeight === taste ||
                      measureOfWeight === teaSpoon ||
                      measureOfWeight === tableSpoon
                    }
                    value={showQuantity}
                    checked={
                      measureOfWeight === taste ||
                      measureOfWeight === teaSpoon ||
                      measureOfWeight === tableSpoon
                        ? false
                        : showQuantity
                    }
                    // defaultChecked={showQuantity}
                    defaultChecked={true}
                    onChange={() =>
                      setShowQuantity(
                        showQuantity === true ? showQuantity === false : !showQuantity,
                      )
                    }
                  ></Checkbox>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </TableBlock>
        <ProductsTagsBlock
          allTags={allTags}
          choosedTags={choosedTags}
          setChoosedTags={setChoosedTags}
          // flexBasis="7%"
          // height="180px"
        />
        <ButtonBlock>
          <Button positive onClick={onHandleSave} loading={isProductLoading}>
            Сохранить
          </Button>
          <Button onClick={onHandleСlear}>Очистить</Button>
        </ButtonBlock>
        <FooterBlock />
        <UpdateProductModal
          isOpen={isShowUpdatePopup}
          onCancel={() => setIsShowUpdatePopup(false)}
          onСreate={onHandleCreate}
          onUpdate={onHandleUpdate}
          title="Вы хотите перезаписать существующий продукт или создать новый?"
        />
      </React.Fragment>
    );
  },
);

const mapStateToProps = (state) => {
  const { allTags, currentProduct, isProductLoading } = state.newYouslim;
  return {
    allTags,
    currentProduct,
    isProductLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getProductTags: (tags) => {
      dispatch(action.getProductTags(tags));
    },
    getProductById: (id) => {
      dispatch(action.getProductById(id));
    },
    createProduct: (data, clear) => {
      dispatch(action.createProduct(data, clear));
    },
    updateProduct: (data, id, clear) => {
      dispatch(action.updateProduct(data, id, clear));
    },
    setCurrentProduct: (product) => {
      dispatch(action.setCurrentProduct(product));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateProductPage);



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/CreateProductPage/index.jsx